export const statusParcel = {
    PENDING:{
        name: 'รอแจ้งลูกค้า',
        empty: 'ไม่มีรายละเอียดข้อมูลรอแจ้งลูกค้า'
    },
    WAITING_FEEDBACK:{
        name: 'รอลูกค้าตอบกลับ',
        empty: 'ไม่มีรายละเอียดข้อมูลรอลูกค้าตอบกลับ'
    },
    REPLIED:{
        name: 'ที่ลูกค้าตอบกลับ',
        empty: 'ไม่มีรายละเอียดข้อมูลที่ลูกค้าตอบกลับ'
    },
    RESOLVED:{
        name: 'จัดการแล้ว',
        empty: 'ไม่มีรายละเอียดข้อมูลจัดการแล้ว'
    }
}